import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
} from "../components/ui/dialog";


const MapModal = ({ isOpen, onClose, latitude, longitude }) => {
    if (!isOpen) return null;

    const latFloat = parseFloat(latitude);
    const longFloat = parseFloat(longitude);

    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>Location Map</DialogTitle>
                </DialogHeader>
                <div className="h-96 w-full bg-gray-100 rounded-lg overflow-hidden">
                    <iframe
                        title={`Map showing location at ${latFloat}, ${longFloat}`}
                        className="w-full h-full border-0"
                        src={`https://www.openstreetmap.org/export/embed.html?bbox=${longFloat - 0.01},${latFloat - 0.01},${longFloat + 0.01},${latFloat + 0.01}&layer=mapnik&marker=${latFloat},${longFloat}`}
                    />

                </div>
                <div className="mt-2 text-sm text-gray-600">
                    Coordinates: {latFloat}, {longFloat}
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default MapModal;